import { Component, OnInit, Input, Optional, Inject } from '@angular/core';
import { LoaderService } from '../../../../shared/sharedServices/loader.service';
import { UploadAdditionalDocumentsService } from '../../../../views/pages/upload-additional-documents/services/upload-additional-documents.service';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SharedService } from '../../../../shared/sharedServices/shared.service';
import { DasDataServiceService } from '../../../../views/pages/das/services/das-data-service.service';
import { Router } from '@angular/router';
import moment from 'moment';

@Component({
  selector: 'kt-comments-list',
  templateUrl: './comments-list.component.html',
  styleUrls: ['./comments-list.component.css']
})
export class CommentsListComponent implements OnInit {
  public commentsList:Array<any>=[];
  public loader:boolean;
  public acronymType:string;
  public statusCodeId:number;
  public optionalDocumentList:any = [];
	combinedDecisionList: Array<any> = HEC_CONSTANTS.CombinedDecisionList;
  @Input() appId: number;
  @Input() btnCancelText: string = 'Cancel';
  constructor(private loaderService:LoaderService, private uploadAdditionalService:UploadAdditionalDocumentsService,
    private dialogRef: MatDialogRef<CommentsListComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private sharedService:SharedService,private dataService: DasDataServiceService,
    private router:Router) { }

  ngOnInit() {
    if(this.data){
    this.acronymType = this.data ? this.data.acronym.toLowerCase() : '';
    this.statusCodeId = this.data ? this.data.statusCodeId:'';
    console.log(this.router.url)
    if(this.router.url == '/des-tracking/tracking'){
      this.getAdminComments('des')
    }else if(this.router.url == '/desf-tracking/tracking'){
      this.getAdminComments('desf')
    }
    else{
      this.getComments(this.data.appId,this.acronymType)
      if(this.acronymType == 'desf' || this.acronymType =='des'){
        this.getDocumentList()
      }
    }
     
  }

  }

  public async 	getAdminComments(acronym) {
		this.sharedService.getCommentsHistory(this.data.appId,acronym)
			.subscribe(response => {
				if (response.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					if (response.data && response.data.length > 0) {            			
						response.data.forEach(element => {
              if(element.comments != ''){
							this.commentsList.push({commentsDate:element.commentsDate,taskName:element.userName,comments:element.comments})
						}
						});
					}
				} else {
				}
			}, error => {
			});
	}

  public decisionTitle(value):void{
    return this.combinedDecisionList.find(d => d.key === value).value
  }

  public async getComments(appId,acronym?):Promise<any>{
    let res;
    try{
    this.loader=true;
    this.loaderService.setValue(this.loader)
    if(this.acronymType == 'das'){
      // res = await this.uploadAdditionalService.getDasComments(appId).toPromise()
      res = await this.uploadAdditionalService.getDasCommentsForDas(appId).toPromise()
      this.getCommentsList(res)
    }else if(this.acronymType == 'des'){
      res = await this.uploadAdditionalService.getDesComments(appId,'des').toPromise()
      this.getCommentsList(res)

    }else if(this.acronymType == 'desf'){
      res = await this.uploadAdditionalService.getDesComments(appId,'desf').toPromise()
      this.getCommentsList(res)

    }
    
  }catch(err){
    this.loader=false;
    this.loaderService.setValue(this.loader)
    console.log('err')
  }
  }

  public getCommentsList(res):void{
    if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
      this.commentsList =[];
      res.data.forEach(element => {
        if(!element.degreeId && element.comments != "" && element.comments != null && element.comments != undefined){
          this.commentsList.push(element);
          console.log(this.commentsList)
        }
      });
      
      this.loader=false;
      this.loaderService.setValue(this.loader)
    }else{      
    }
  }

  public getDate(date):void {
    return this.sharedService.getDate(date);
  }

  public decline() {
    this.dialogRef.close(false);
  }

  public accept() {
    this.dialogRef.close(true);
  }

  public dismiss(type) {
    this.dialogRef.close(false);
  }

  public goToTask():void{
    if(this.statusCodeId == 90017 || this.statusCodeId == 202620 || this.statusCodeId == 20266){
      this.decline();
      this.dataService.setAppData(this.data.appId, this.acronymType, 'dasRevision', undefined);
      // this.dataService.setApplicationId(this.data.appId,this.acronymType,'dasRevision');
        this.router.navigate(['/das-app']);
      }
  }


  public getDocumentList():void{
    this.loader = true;
    this.loaderService.setValue(this.loader);
    let payload = {
      data: {
        applicationId: this.data.appId,
        processAcronym: this.data.acronym
      }
    }
    this.sharedService.getDocumentList(payload).subscribe(
      (res)=>{
        if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
          res.data.forEach(element => {
            if(element.category == 'Policy Document'){
          this.optionalDocumentList.push({
            docId: element.documentId,
            fileName:element.title,
            documentType:'Revision Requested'
          });
        }
          });
          this.loader = false;
          this.loaderService.setValue(this.loader);
        }else{
          this.loader = false
          this.loaderService.setValue(this.loader);
        }
      },
    (err)=>{
      this.loaderService.setValue(false);

    }
    )
    
  }
}
